import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { CustomInput } from 'src/consumer/components/helperComponents'

export default function HealthEntityAddPopover({
  healthEntity,
  addToHealthEntityArray,
  closePopover,
  preferredLanguages = ['en'],
  healthEntityName = '',
  apiParam,
}) {
  const [currentHealthEntity, setCurrentHealthEntity] = useState(healthEntity)
  const healthEntityInputRef = useRef()
  const translationInputRef = useRef()
  const submitButtonRef = useRef()
  const [stopAutoFocus, setStopAutoFocus] = useState(false)

  async function saveAndSetHealthEntity() {
    addToHealthEntityArray({
      ...currentHealthEntity,
      value: currentHealthEntity?.label,
      label: `${currentHealthEntity?.label}${
        preferredLanguages?.includes('hi')
          ? `${
              currentHealthEntity?.translations?.hi?.title
                ? ` (${currentHealthEntity?.translations?.hi?.title})`
                : ''
            }`
          : ''
      }`,
      __isNew__: true,
      translations: {
        ...currentHealthEntity?.translations,
        en: {
          title: currentHealthEntity?.label,
        },
      },
    })
    closePopover()
  }
  const handleKeyDown = (e) => {
    console.log({ e, key: e.key, keyCode: e.keyCode })
    if (
      (e.key === 'Enter' || e.keyCode === 13) &&
      (document.activeElement === healthEntityInputRef.current ||
        document.activeElement === translationInputRef.current)
    ) {
      submitButtonRef?.current?.click()
    }
  }

  function inputEnterThing(inputRef) {
    return () => {
      var inputElement = inputRef?.current
      if (inputRef?.current) {
        inputElement.addEventListener('keydown', handleKeyDown)
      }

      return () => {
        inputElement?.removeEventListener('keydown', handleKeyDown)
      }
    }
  }

  useEffect(() => {
    if (healthEntityInputRef?.current && !stopAutoFocus) {
      healthEntityInputRef?.current.focus()
      setStopAutoFocus(true)
    }
  }, [healthEntityInputRef.current])

  useEffect(inputEnterThing(healthEntityInputRef), [healthEntityInputRef, submitButtonRef])

  useEffect(inputEnterThing(translationInputRef), [translationInputRef, submitButtonRef])

  useEffect(() => {
    console.log(currentHealthEntity)
  }, [currentHealthEntity])

  return (
    <>
      <DialogTitle sx={{ padding: '6px 18px' }}>Create {healthEntityName}</DialogTitle>
      <DialogContent sx={{ padding: '6px 18px', width: '400px' }}>
        <CustomInput
          inputRef={healthEntityInputRef}
          value={currentHealthEntity?.label}
          onChange={(e) => {
            setCurrentHealthEntity((prev) => ({
              ...prev,
              label: e.target.value,
              value: e.target.value,
            }))
          }}
        />
        <br></br>
        {preferredLanguages?.includes('hi') && (
          <>
            <h5>Translations</h5>
            <CustomInput
              inputRef={translationInputRef}
              label="Hindi"
              value={currentHealthEntity?.translations?.hi?.title}
              onChange={(e) => {
                setCurrentHealthEntity((prev) => ({
                  ...prev,
                  translations: {
                    ...(prev?.translations || {}),
                    hi: {
                      title: e.target.value,
                    },
                  },
                }))
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={closePopover} sx={{ color: '#000' }} variant="text">
          Cancel
        </Button>
        <Button
          ref={submitButtonRef}
          size="small"
          variant="contained"
          onClick={saveAndSetHealthEntity}
        >
          Create
        </Button>
      </DialogActions>
    </>
  )
}
